/**
 * atomberg-color-tiles.js
 * ────────────────────────
 * Enables mouse drag-to-scroll on the PDP color tile row, matching the ETR
 * carousel behavior. Requires atomberg-drag-scroll.js to load first.
 */
(function () {
  /** @type {any} */
  var w = window;
  if (w._atombergColorTilesInit) return;
  w._atombergColorTilesInit = true;

  function start() {
    if (!w.AtombergDragScroll) return;
    document.querySelectorAll('.atomberg-color-tiles__row').forEach(function (el) {
      w.AtombergDragScroll.enable(el, { dragClass: 'atomberg-color-tiles__row--dragging' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
